import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedLocations } from '@hooks/mocks/locations'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface ILocations {
  code: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
}

export const useFindSiteLocations = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const fetchSiteAreas = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/locations`
      const { data } = await api.get<ILocations[]>(url)
      return data
    }
    return mockedLocations
  }

  return useQuery({ queryKey: ['LOCATIONS'], queryFn: fetchSiteAreas })
}
